module.exports = __webpack_public_path__ + "images/88cce906c2340a172df29d06f708ae82-sun.png";